// Copyright (c) 2026 by Audere

import {
  BaseQueryApi,
  FetchArgs,
  FetchBaseQueryError,
  createApi,
  fetchBaseQuery,
} from "@reduxjs/toolkit/query/react";

import { State as AuthState } from "../auth/authSlice";
import { googleLogout } from "@react-oauth/google";
import { logOut } from "../auth/authSlice";

const isProd = () => {
  const host = window.location.hostname;
  return !host.includes(".staging.") && !host.includes("localhost");
};

const apiBaseURL = () => {
  const apiHost = isProd()
    ? "ficus.af-south-1.epistore.auderenow.io"
    : "ficus.af-south-1.epistore.staging.auderenow.io";
  return `https://${apiHost}/v1/ficus`;
};

const baseQuery = fetchBaseQuery({
  baseUrl: apiBaseURL(),
  mode: "cors",
  credentials: "include",
  prepareHeaders: (headers, { getState }) => {
    headers.set("Content-Type", "application/json");
    if (!headers.get("X-Audere-API-Token")) {
      const state = getState() as { auth: AuthState };
      const token = state.auth.token;
      if (token) {
        headers.set("X-Audere-API-Token", `${token}`);
      }
    }
    return headers;
  },
  timeout: 45000,
});

const baseQueryWithReauth = async (
  args: string | FetchArgs,
  api: BaseQueryApi,
  extraOptions: object
) => {
  if (api.endpoint !== "openIdAuthenticate") {
    const getStateT = api.getState as () => { auth: AuthState };
    const auth = getStateT().auth;

    if (auth.token && new Date(auth.expires) < new Date(Date.now())) {
      console.log("Expired token - logging out");
      googleLogout();
      api.dispatch(logOut());
      api.dispatch(apiSlice.util.resetApiState());
      return {
        error: {
          status: "CUSTOM_ERROR",
          error: "Token has expired",
        } as FetchBaseQueryError,
      };
    }
  }

  return baseQuery(args, api, extraOptions);
};

export const apiSlice = createApi({
  baseQuery: baseQueryWithReauth,
  endpoints: () => ({}),
});
